<template>
  <div>
    <page-navigate></page-navigate>
    <section class="esg-hero" data-module="esg-hero">
      <div class="esg-hero__media" aria-hidden="true">
        <video class="esg-hero__video" muted playsinline loop autoplay preload="metadata"></video>
      </div>
      <div class="esg-hero__topShade" aria-hidden="true"></div>

      <div class="esg-hero__content">
        <div class="esg-hero__text">
          <h1 class="esg-hero__title">责任，跨越时区和边界</h1>
          <p class="esg-hero__subtitle">为真实的人，做负责任的事</p>
        </div>
        <a class="esg-hero__btn" href="/malaria">查看最新进展</a>
      </div>
    </section>

    <section class="esg-latest scroll-fade-up" id="latest" data-module="esg-latest">
      <div class="esg-latest__wrap">
        <div class="esg-latest__cards" role="list">
          <article class="esg-latestCard esg-latestCard--1" role="listitem">
            <div class="esg-latestCard__media" aria-hidden="true">
              <picture>
                <source media="(max-width: 996px)" srcset="@/assets/image/ESG/section2Bg1M.webp" />
                <img src="@/assets/image/ESG/section2Bg1.webp" alt="" loading="lazy" />
              </picture>
            </div>
            <div class="esg-latestCard__shade" aria-hidden="true"></div>
            <div class="esg-latestCard__text">
              <h3 class="esg-latestCard__title">EBC携手世界女童军协会</h3>
              <p class="esg-latestCard__desc">
                赋能全球处境弱势女性和女童，共创更有温度与活力的明天
              </p>
            </div>
            <a class="esg-latestCard__more" href="/LearningCenterInfo?id=LEARN-814-37E">
              <span>了解更多</span>
              <svg class="esg-latestCard__arrow" width="20" height="20" viewBox="0 0 20 20" fill="none"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path d="M8 4L13 10L8 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </a>
          </article>

          <article class="esg-latestCard esg-latestCard--2" role="listitem">
            <div class="esg-latestCard__media" aria-hidden="true">
              <picture>
                <source media="(max-width: 996px)" srcset="@/assets/image/ESG/section2Bg2M.webp" />
                <img src="@/assets/image/ESG/section2Bg2.webp" alt="" loading="lazy" />
              </picture>
            </div>
            <div class="esg-latestCard__shade" aria-hidden="true"></div>
            <div class="esg-latestCard__text">
              <h3 class="esg-latestCard__title">在全球各地扶老济幼</h3>
              <p class="esg-latestCard__desc">
                EBC携手全球多家慈善机构，帮扶孤寡老人及困境儿童。
              </p>
            </div>
            <a class="esg-latestCard__more" href="/LearningCenterInfo?id=LEARN-944-382">
              <span>了解更多</span>
              <svg class="esg-latestCard__arrow" width="20" height="20" viewBox="0 0 20 20" fill="none"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path d="M8 4L13 10L8 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </a>
          </article>

          <article class="esg-latestCard esg-latestCard--3" role="listitem">
            <div class="esg-latestCard__media" aria-hidden="true">
              <picture>
                <source media="(max-width: 996px)" srcset="@/assets/image/ESG/section2Bg3M.webp" />
                <img src="@/assets/image/ESG/section2Bg3.webp" alt="" loading="lazy" />
              </picture>
            </div>
            <div class="esg-latestCard__shade" aria-hidden="true"></div>
            <div class="esg-latestCard__text">
              <h3 class="esg-latestCard__title">让经济学走进每一个人</h3>
              <p class="esg-latestCard__desc">
                EBC联合牛津大学等学府及教育机构，让前沿经济学惠及更多人。
              </p>
            </div>
            <a class="esg-latestCard__more" href="/oxford">
              <span>了解更多</span>
              <svg class="esg-latestCard__arrow" width="20" height="20" viewBox="0 0 20 20" fill="none"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path d="M8 4L13 10L8 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </a>
          </article>
        </div>
      </div>
    </section>

    <section class="esg-stats" data-module="esg-stats">
      <h2 class="esg-stats__title scroll-fade-up">数字在说话，行动有回响</h2>

      <div class="esg-stats__wrap">
        <div class="esg-stats__grid scroll-fade-up" role="list">
          <div class="esg-stat" role="listitem">
            <div class="esg-stat__value" data-count="10" data-prefix="$" data-suffix="M+">
              $0M+
            </div>
            <div class="esg-stat__label">公益累计捐赠金额</div>
          </div>

          <div class="esg-stat" role="listitem">
            <div class="esg-stat__value" data-count="15" data-suffix="W+">
              0W+
            </div>
            <div class="esg-stat__label">不被疟疾侵扰</div>
          </div>

          <div class="esg-stat" role="listitem">
            <div class="esg-stat__value" data-count="87" data-suffix="W+">
              0W+
            </div>
            <div class="esg-stat__label">原生树木守护</div>
          </div>

          <div class="esg-stat" role="listitem">
            <div class="esg-stat__value" data-count="100" data-suffix="+">
              0+
            </div>
            <div class="esg-stat__label">全球顶尖学术研讨</div>
          </div>
        </div>
      </div>
    </section>

    <section class="esg-vision" data-module="esg-vision">
      <div class="esg-vision__inner">
        <h2 class="esg-vision__title scroll-fade-up">我们的愿景</h2>

        <div class="esg-vision__grid scroll-fade-up" role="list">
          <article class="esg-visionCard" role="listitem">
            <div class="esg-visionCard__icon" aria-hidden="true">
              <img src="@/assets/image/ESG/section4Logo1.webp" alt="" />
            </div>
            <div class="esg-visionCard__body">
              <h3 class="esg-visionCard__title">用教育拓宽未来</h3>
              <p class="esg-visionCard__desc">
                让知识流动起来，让更多人拥有改变命运的能力
              </p>
            </div>
          </article>

          <article class="esg-visionCard esg-visionCard--raised" role="listitem">
            <div class="esg-visionCard__icon" aria-hidden="true">
              <img src="@/assets/image/ESG/section4Logo2.webp" alt="" />
            </div>
            <div class="esg-visionCard__body">
              <h3 class="esg-visionCard__title">共建平等社会</h3>
              <p class="esg-visionCard__desc">
                支持社区与慈善活动，赋予更多人平等的权利
              </p>
            </div>
          </article>

          <article class="esg-visionCard" role="listitem">
            <div class="esg-visionCard__icon" aria-hidden="true">
              <img src="@/assets/image/ESG/section4Logo3.webp" alt="" />
            </div>
            <div class="esg-visionCard__body">
              <h3 class="esg-visionCard__title">让员工引以为傲</h3>
              <p class="esg-visionCard__desc">
                让每一位员工在开放与包容的环境中，实现价值与成长
              </p>
            </div>
          </article>

          <article class="esg-visionCard" role="listitem">
            <div class="esg-visionCard__icon" aria-hidden="true">
              <img src="@/assets/image/ESG/section4Logo4.webp" alt="" />
            </div>
            <div class="esg-visionCard__body">
              <h3 class="esg-visionCard__title">建设绿色家园</h3>
              <p class="esg-visionCard__desc">
                将可持续发展纳入公司的长期规划中，倡导节约资源，建设理想家园
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>

    <section class="esg-action" data-module="esg-action">
      <h2 class="esg-action__title scroll-fade-up">我们持续在行动</h2>

      <div class="esg-action__wrap scroll-fade-up" role="list">
        <article class="esg-actionCard esg-actionCard--1" role="listitem">
          <div class="esg-actionCard__shade" aria-hidden="true"></div>
          <div class="esg-actionCard__text">
            <h3 class="esg-actionCard__title">教育资金 </h3>
            <p class="esg-actionCard__desc">
              EBC内设专项资金，资助资源贫乏地区的儿童及公共教育
            </p>
          </div>
        </article>

        <article class="esg-actionCard esg-actionCard--2" role="listitem">
          <div class="esg-actionCard__shade" aria-hidden="true"></div>
          <div class="esg-actionCard__text">
            <h3 class="esg-actionCard__title">医疗基金</h3>
            <p class="esg-actionCard__desc">
              内设医疗基金，为失独老人、患病儿童送去希望之光
            </p>
          </div>
        </article>

        <article class="esg-actionCard esg-actionCard--3" role="listitem">
          <div class="esg-actionCard__shade" aria-hidden="true"></div>
          <div class="esg-actionCard__text">
            <h3 class="esg-actionCard__title">关爱基金</h3>
            <p class="esg-actionCard__desc">
              内设员工关怀资金，用于协助员工孝敬父母，友爱兄弟姐妹
            </p>
          </div>
        </article>

        <article class="esg-actionCard esg-actionCard--4" role="listitem">
          <div class="esg-actionCard__shade" aria-hidden="true"></div>
          <div class="esg-actionCard__text">
            <h3 class="esg-actionCard__title">捐赠基金</h3>
            <p class="esg-actionCard__desc">
              灾难之后，每个人都是重建者。EBC通过内部资金，为疫区人民送去关怀
            </p>
          </div>
        </article>
      </div>
    </section>
    <div class="esg-6">
      <div class="scroll-fade-up">
        <p class="p1">进展与故事</p>
        <div class="esg-6_list swiper flex">
          <div class="swiper-wrapper">
              <div class="esg-6_item swiper-slide" v-for="item in newData">
                <a :href="item.url">
                  <img :src="item.thumbnail" loading="lazy"/>
                </a>
                <p class="time">{{ item.published_time }}</p>
                <a :href="item.url" class="title">{{ item.post_title }}</a>
              </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
import fadeAnimate from "../mixins/fadeAnimate.js";
import {
  mapState,
} from 'vuex'
export default {
  mixins: [fadeAnimate],

  data() {
    return {
      infoData: "",
      newData: "",
      pagIndex: 0,
      topNum: 360,
      navLock: ""
    }
  },
  computed: {
    ...mapState({
      lang: state => state.Lan,
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.scroll, false)
  },
  created() {

  },
  async mounted() {
    document.documentElement.setAttribute("data-theme", "dark");
    await this.getNewData()
    this.initPage()
  },
  methods: {
    initPage() {
      (() => {
        const HERO_SELECTOR = '[data-module="esg-hero"]';
        const VIDEO_SELECTOR = ".esg-hero__video";
        const LATEST_SELECTOR = '[data-module="esg-latest"]';
        const LATEST_CARDS_SELECTOR = ".esg-latest__cards";
        const LATEST_CARD_SELECTOR = ".esg-latestCard";
        const STATS_SELECTOR = '[data-module="esg-stats"]';
        const STAT_VALUE_SELECTOR = ".esg-stat__value";

        const SRC_PC = require("../assets/image/ESG/section1BgVideo.mp4");
        const SRC_M = require("../assets/image/ESG/section1BgMVideo.mp4");
        const POSTER_PC = require("../assets/image/ESG/section1Bg.webp");
        const POSTER_M = require("../assets/image/ESG/section1BgM.webp");

        function isMobile() {
          return window.matchMedia && window.matchMedia("(max-width: 996px)").matches;
        }

        function setLatestActive(cardsEl, idx) {
          if (!cardsEl) return;
          cardsEl.classList.remove("is-active-1", "is-active-2", "is-active-3");
          cardsEl.classList.add(`is-active-${idx}`);
        }

        function setVideoSource(videoEl, src, poster) {
          if (!videoEl) return;
          if (videoEl.dataset.src === src) return;

          videoEl.dataset.src = src;
          videoEl.setAttribute("poster", poster);

          while (videoEl.firstChild) videoEl.removeChild(videoEl.firstChild);
          const source = document.createElement("source");
          source.src = src;
          source.type = "video/mp4";
          videoEl.appendChild(source);

          try {
            videoEl.load();
          } catch (e) {
            // no-op
          }
        }

        function tryPlay(videoEl, heroEl) {
          if (!videoEl) return;

          const onCanPlay = () => {
            heroEl && heroEl.classList.add("is-video-ready");
            const p = videoEl.play();
            if (p && typeof p.catch === "function") p.catch(() => { });
          };

          videoEl.addEventListener("canplay", onCanPlay, { once: true });

          const p = videoEl.play();
          if (p && typeof p.catch === "function") p.catch(() => { });
        }

        function initHero() {
          const heroEl = document.querySelector(HERO_SELECTOR);
          if (!heroEl) return;

          const videoEl = heroEl.querySelector(VIDEO_SELECTOR);
          if (!videoEl) return;

          const apply = () => {
            const mobile = isMobile();
            setVideoSource(
              videoEl,
              mobile ? SRC_M : SRC_PC,
              mobile ? POSTER_M : POSTER_PC,
            );
            tryPlay(videoEl, heroEl);
          };
          setTimeout(() => {
            apply();
          }, 500);

          let t = null;
          window.addEventListener("resize", () => {
            clearTimeout(t);
            t = setTimeout(apply, 150);
          });
        }

        function initLatest() {
          const rootEl = document.querySelector(LATEST_SELECTOR);
          if (!rootEl) return;

          const cardsEl = rootEl.querySelector(LATEST_CARDS_SELECTOR);
          if (!cardsEl) return;

          const cards = Array.from(cardsEl.querySelectorAll(LATEST_CARD_SELECTOR));
          if (!cards.length) return;

          const mqDesktop =
            window.matchMedia && window.matchMedia("(min-width: 997px)");

          const apply = () => {
            if (!mqDesktop || !mqDesktop.matches) {
              cardsEl.classList.remove("is-active-1", "is-active-2", "is-active-3");
              return;
            }
            setLatestActive(cardsEl, 1);
          };

          apply();

          cards.forEach((cardEl, i) => {
            const idx = i + 1;

            cardEl.addEventListener("mouseenter", () => {
              if (!mqDesktop || !mqDesktop.matches) return;
              setLatestActive(cardsEl, idx);
            });

            cardEl.addEventListener("focusin", () => {
              if (!mqDesktop || !mqDesktop.matches) return;
              setLatestActive(cardsEl, idx);
            });
          });

          if (mqDesktop) {
            if (typeof mqDesktop.addEventListener === "function") {
              mqDesktop.addEventListener("change", apply);
            } else if (typeof mqDesktop.addListener === "function") {
              mqDesktop.addListener(apply);
            }
          }
        }

        function easeOutCubic(t) {
          return 1 - Math.pow(1 - t, 3);
        }

        function animateCount(
          el,
          to,
          { prefix = "", suffix = "", duration = 1200 } = {},
        ) {
          const prefersReduced =
            window.matchMedia &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          const target = Number(to);
          if (!isFinite(target)) return;

          if (prefersReduced) {
            el.textContent = `${prefix}${Math.round(target)}${suffix}`;
            return;
          }

          const from = 0;
          const start = performance.now();

          const tick = (now) => {
            const p = Math.min(1, (now - start) / duration);
            const v = from + (target - from) * easeOutCubic(p);
            el.textContent = `${prefix}${Math.round(v)}${suffix}`;
            if (p < 1) requestAnimationFrame(tick);
          };

          requestAnimationFrame(tick);
        }

        function initStats() {
          const rootEl = document.querySelector(STATS_SELECTOR);
          if (!rootEl) return;

          const values = Array.from(rootEl.querySelectorAll(STAT_VALUE_SELECTOR));
          if (!values.length) return;

          const once = new WeakSet();

          const run = (el) => {
            if (once.has(el)) return;
            once.add(el);
            const count = el.getAttribute("data-count");
            const prefix = el.getAttribute("data-prefix") || "";
            const suffix = el.getAttribute("data-suffix") || "";
            animateCount(el, count, { prefix, suffix, duration: 1200 });
          };

          if (!("IntersectionObserver" in window)) {
            values.forEach(run);
            return;
          }

          const io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                run(entry.target);
                io.unobserve(entry.target);
              });
            },
            { root: null, threshold: 0.35 },
          );

          values.forEach((el) => io.observe(el));
        }
        function initSeamless() {
          new Swiper(".esg-6_list", {
            loop: true, // 开启循环模式
            slidesPerView: "auto", // 视口展示的 slide 数量，建议设为 auto 或具体数字（如 4）
            spaceBetween: 20, // slide 之间的间距
            speed: 6000, // 滚动速度（毫秒），数值越大滚动越慢
            autoplay: {
              delay: 0, // 必须为 0，确保没有停顿
              disableOnInteraction: false, // 用户手动操作后，不停止自动轮播
            },
          });
        }
        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", () => {
            initHero();
            initLatest();
            initStats();
            initSeamless();
          });
        } else {
          initHero();
          initLatest();
          initStats();
          initSeamless();
        }
      })();

    },
     timeRevert(timestamp){
          const date = new Date(timestamp * 1000);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return  `${year}-${month}-${day}`;
        },
    getNewData() {
      
      return fetch('https://academy.ebccfd.com/api/academy-social-responsibility?lang=zh_CN&type=social').then(res=>res.json()).then(res=>{
            res.data.list.forEach(i=>{
              i.published_time = this.timeRevert(i.published_time)
            })
            this.newData = res.data.list
          })
    },
 

  }
}

</script>

<style scoped>
/* ESG - first screen (hero) */

.esg-hero {
  position: relative;
  width: 100%;
  height: 938rem;
  background: #000 url("../assets/image/ESG/section1Bg.webp") center / cover no-repeat;
  overflow: hidden;
}

.esg-hero__media {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.esg-hero__video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0;
  transition: opacity 240ms ease;
}

.esg-hero.is-video-ready .esg-hero__video {
  opacity: 1;
}

.esg-hero__topShade {
  position: absolute;
  inset: 0;
  width: 100%;
  background: linear-gradient(0deg,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0.2) 100%);
}

.esg-hero__content {
  position: absolute;
  left: 50%;
  top: calc(50% + 30rem);
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64rem;
  text-align: center;
  width: 100%;
  padding: 0 32rem;
}

.esg-hero__text {
  display: flex;
  flex-direction: column;
  gap: 24rem;
  align-items: center;
  color: #fff;
}

.esg-hero__title {
  margin: 0;
  font-size: 72rem;
  line-height: 80rem;
  font-weight: 700;
}

@media (min-width: 996px) {
  .esg-hero__title {
    max-width: 80vw;
  }
}

.esg-hero__subtitle {
  margin: 0;
  font-size: 20rem;
  line-height: 28rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
}

.esg-hero__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48rem;
  padding: 10rem 40rem;
  border-radius: 999rem;
  background: #a52933;
  color: #fff;
  font-size: 16rem;
  line-height: 28rem;
  font-weight: 500;
  text-decoration: none;
  box-sizing: border-box;
}

.esg-hero__btn:hover {
  background: var(--ebc-basecolor-active-400);
}

.esg-hero__btn:hover {
  color: #fff;
  opacity: 0.92;
}

.swiper-wrapper {
  -webkit-transition-timing-function: linear !important;
  transition-timing-function: linear !important;
}

@media (max-width: 996px) {

  /* 375 design values ×2 */
  .esg-hero {
    height: 1518rem;
    /* 759 * 2 */
    background-image: url("../assets/image/ESG/section1BgM.webp");
    margin-top: -44px;
  }

  .esg-hero__content {
    left: 32rem;
    /* 16 * 2 */
    top: calc(50% + 70rem);
    /* 35 * 2 */
    transform: translateY(-50%);
    width: calc(100% - 64rem);
    padding: 0;
    gap: 64rem;
    /* 32 * 2 */
  }

  .esg-hero__title {
    font-size: 64rem;
    /* 32 * 2 */
    line-height: 80rem;
    /* 40 * 2 */
    white-space: normal;
  }

  .esg-hero__subtitle {
    font-size: 28rem;
    /* 14 * 2 */
    line-height: 44rem;
    /* 22 * 2 */
    white-space: normal;
  }

  .esg-hero__text {
    gap: 16rem;
  }

  .esg-hero__btn {
    padding: 20rem 112rem;
    height: 96rem;
    font-size: 32rem;
    line-height: 56rem;
  }
}

/* ESG - latest (section2 cards) */

.esg-latest {
  width: 100%;
  background: #f7f7f7;
  padding: 120rem 0;
}

.esg-latest__wrap {
  width: 1200rem;
  margin: 0 auto;
}

.esg-latest__cards {
  display: flex;
  gap: 20rem;
  align-items: flex-start;
  justify-content: center;
  height: 480rem;
}

.esg-latestCard {
  position: relative;
  height: 480rem;
  width: 220rem;
  border-radius: 24rem;
  overflow: hidden;
  flex: 0 0 auto;
  color: #fff;
}

@media (min-width: 997px) {
  .esg-latestCard {
    transition: width 320ms ease;
  }

  /* PC active state (JS-controlled): expand active, others collapse */
  .esg-latest__cards.is-active-1 .esg-latestCard--1,
  .esg-latest__cards.is-active-2 .esg-latestCard--2,
  .esg-latest__cards.is-active-3 .esg-latestCard--3 {
    width: 720rem;
  }

  .esg-latest__cards.is-active-2 .esg-latestCard--1,
  .esg-latest__cards.is-active-3 .esg-latestCard--1 {
    width: 220rem;
  }
}

.esg-latestCard__media {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.esg-latestCard__media picture,
.esg-latestCard__media img {
  display: block;
  width: 100%;
  height: 100%;
}

.esg-latestCard__media img {
  object-fit: cover;
}

.esg-latestCard--1 .esg-latestCard__media img {
  object-position: 20% center;
}

.esg-latestCard--2 .esg-latestCard__media img {
  object-position: 70% center;
}

.esg-latestCard--3 .esg-latestCard__media img {
  object-position: center center;
}

.esg-latestCard__shade {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 200rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, #000 100%);
  mix-blend-mode: multiply;
  opacity: 0.7;
  pointer-events: none;
}

.esg-latestCard__text {
  position: absolute;
  left: 32rem;
  bottom: 40rem;
  display: flex;
  flex-direction: column;
  gap: 12rem;
  max-width: 156rem;
}

.esg-latestCard__title {
  margin: 0;
  font-size: 24rem;
  line-height: 32rem;
  font-weight: 500;
}

/* PC: collapsed cards clamp title to 4 lines */
@media (min-width: 997px) {
  .esg-latestCard__title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 128rem;
    /* 32 * 4 */
  }

  /* active card title should not be clamped */
  .esg-latest__cards.is-active-1 .esg-latestCard--1 .esg-latestCard__title,
  .esg-latest__cards.is-active-2 .esg-latestCard--2 .esg-latestCard__title,
  .esg-latest__cards.is-active-3 .esg-latestCard--3 .esg-latestCard__title {
    display: block;
    -webkit-line-clamp: unset;
    line-clamp: unset;
    overflow: visible;
    text-overflow: clip;
    max-height: none;
  }

  .esg-latestCard__desc {
    display: none;
  }

  .esg-latest__cards.is-active-1 .esg-latestCard--1 .esg-latestCard__desc,
  .esg-latest__cards.is-active-2 .esg-latestCard--2 .esg-latestCard__desc,
  .esg-latest__cards.is-active-3 .esg-latestCard--3 .esg-latestCard__desc {
    display: block;
  }
}

.esg-latestCard__desc {
  margin: 0;
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.92);
}

.esg-latestCard__more {
  position: absolute;
  left: 32rem;
  bottom: 40rem;
  display: inline-flex;
  align-items: center;
  gap: 4rem;
  font-size: 14rem;
  line-height: 22rem;
  color: #fff;
  text-decoration: none;
  white-space: nowrap;
}

.esg-latestCard__more:hover {
  opacity: 0.9;
  color: #fff;
}

.esg-latestCard__arrow {
  flex: 0 0 auto;
}

.esg-latestCard__more:hover .esg-latestCard__arrow {
  animation: arrowNudgeRight 0.6s ease-out;
}

/* 新增：定义箭头向右移动再复原的关键帧动画 */
@keyframes arrowNudgeRight {
  0% {
    opacity: 0;
    transform: translateX(-10rem);
    /* 保持与初始状态一致的偏移 */
  }

  100% {
    opacity: 1;
    /* 变为完全可见 */
    transform: translateX(0);
    /* 回到原位 */
  }
}

/* collapsed cards: only show title */
.esg-latestCard__desc,
.esg-latestCard__more {
  opacity: 0;
  visibility: hidden;
  transform: translateY(6rem);
  transition:
    opacity 220ms ease,
    transform 220ms ease,
    visibility 0s linear 220ms;
}

@media (min-width: 997px) {

  /* active card should behave like expanded card */
  .esg-latest__cards.is-active-1 .esg-latestCard--1 .esg-latestCard__text,
  .esg-latest__cards.is-active-2 .esg-latestCard--2 .esg-latestCard__text,
  .esg-latest__cards.is-active-3 .esg-latestCard--3 .esg-latestCard__text {
    left: 40rem;
    bottom: 40rem;
    top: auto;
    right: 160rem;
    /* leave room for "了解更多" */
    max-width: 68%;
  }

  .esg-latest__cards.is-active-1 .esg-latestCard--1 .esg-latestCard__more,
  .esg-latest__cards.is-active-2 .esg-latestCard--2 .esg-latestCard__more,
  .esg-latest__cards.is-active-3 .esg-latestCard--3 .esg-latestCard__more {
    left: auto;
    right: 40rem;
    bottom: 40rem;
    top: auto;
  }

  .esg-latest__cards.is-active-1 .esg-latestCard--1 .esg-latestCard__desc,
  .esg-latest__cards.is-active-1 .esg-latestCard--1 .esg-latestCard__more,
  .esg-latest__cards.is-active-2 .esg-latestCard--2 .esg-latestCard__desc,
  .esg-latest__cards.is-active-2 .esg-latestCard--2 .esg-latestCard__more,
  .esg-latest__cards.is-active-3 .esg-latestCard--3 .esg-latestCard__desc,
  .esg-latest__cards.is-active-3 .esg-latestCard--3 .esg-latestCard__more {
    opacity: 1;
    visibility: visible;
    transform: none;
    transition:
      opacity 220ms ease,
      transform 220ms ease;
  }
}

@media (max-width: 996px) {
  .esg-latest {
    padding: 80rem 0;
    /* 40 * 2 */
  }

  .esg-latest__wrap {
    width: 100%;
    padding: 0 32rem;
    /* 16 * 2 */
  }

  .esg-latest__cards {
    height: auto;
    flex-direction: column;
    gap: 32rem;
    /* 16 * 2 */
  }

  .esg-latestCard,
  .esg-latestCard--1,
  .esg-latest__cards.is-active-1 .esg-latestCard,
  .esg-latest__cards.is-active-2 .esg-latestCard,
  .esg-latest__cards.is-active-3 .esg-latestCard {
    width: 100%;
    height: auto;
    transition: none;
  }

  .esg-latestCard {
    background: #fff;
    border-radius: 32rem;
    /* 16 * 2 */
    padding: 56rem 32rem;
    /* 28 * 2, 16 * 2 */
    color: #000;
    display: flex;
    flex-direction: column;
  }

  .esg-latestCard__text {
    position: static;
    order: 0;
    max-width: none;
    gap: 16rem;
    /* 8 * 2 */
  }

  .esg-latestCard__title {
    font-size: 36rem;
    /* 18 * 2 */
    line-height: 52rem;
    /* 26 * 2 */
    color: #000;
  }

  .esg-latestCard__desc {
    font-size: 28rem;
    /* 14 * 2 */
    line-height: 48rem;
    /* 24 * 2 */
    color: rgba(0, 0, 0, 0.8);
  }

  .esg-latestCard__media {
    position: static;
    order: 1;
    width: 100%;
    height: 312rem;
    /* 156 * 2 */
    border-radius: 16rem;
    /* 8 * 2 */
    overflow: hidden;
    margin-top: 40rem;
    /* 24 * 2 */
  }

  .esg-latestCard__shade {
    display: none;
  }

  .esg-latestCard__more {
    position: static;
    order: 2;
    margin-top: 48rem;
    /* 12 * 2 */
    align-self: flex-end;
    color: #000;
    font-size: 28rem;
  }

  .esg-latestCard__desc,
  .esg-latestCard__more {
    opacity: 1;
    visibility: visible;
    transform: none;
  }

  .esg-latestCard__more:hover {
    color: #000;
    opacity: 0.9;
  }
}

/* ESG - stats (section3 numbers) */

.esg-stats {
  width: 100%;
  background: #fff;
  padding: 120rem 0;
  text-align: center;
}

.esg-stats__title {
  margin: 0;
  font-size: 40rem;
  line-height: 48rem;
  font-weight: 700;
  color: #000;
}

.esg-stats__wrap {
  width: 1250rem;
  margin: 64rem auto 0;
}

.esg-stats__grid {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 20rem;
}

.esg-stat {
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  gap: 12rem;
  align-items: center;
}

.esg-stat__value {
  font-size: 72rem;
  line-height: 80rem;
  font-weight: 700;
  color: #a52933;
}

.esg-stat__label {
  font-size: 16rem;
  line-height: 24rem;
  font-weight: 400;
  color: #364153;
}

@media (max-width: 996px) {

  /* 375 design values ×2 */
  .esg-stats {
    padding: 160rem 0;
    /* 80 * 2 */
  }

  .esg-stats__title {
    padding: 0 32rem;
    /* 16 * 2 */
    font-size: 48rem;
    /* 24 * 2 */
    line-height: 72rem;
    /* 36 * 2 */
  }

  .esg-stats__wrap {
    width: 100%;
    margin-top: 80rem;
    /* 40 * 2 */
    padding: 0 32rem;
    /* 16 * 2 */
    box-sizing: border-box;
  }

  .esg-stats__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 80rem 10rem;
    /* 40 * 2 */
    justify-items: center;
  }

  .esg-stat {
    gap: 16rem;
    /* 8 * 2 */
  }

  .esg-stat__value {
    font-size: 64rem;
    /* 32 * 2 */
    line-height: 80rem;
    /* 40 * 2 */
  }

  .esg-stat__label {
    font-size: 28rem;
    /* 14 * 2 */
    line-height: 44rem;
    /* 22 * 2 */
  }
}

/* ESG - vision (section4) */

.esg-vision {
  width: 100%;
  background: #fff;
  padding-bottom: 120rem;
}

.esg-vision__inner {
  width: 1500rem;
  /* PC content block width */
  margin: 0 auto;
  background: #f9f6f2;
  border-radius: 40rem;
  padding: 120rem 150rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64rem;
}

.esg-vision__title {
  margin: 0;
  font-size: 40rem;
  line-height: 48rem;
  font-weight: 700;
  color: #000;
  text-align: center;
}

.esg-vision__grid {
  width: 1200rem;
  display: flex;
  gap: 20rem;
  align-items: stretch;
  justify-content: center;
}

.esg-visionCard {
  flex: 0 0 auto;
  width: 285rem;
  background: #fff;
  border-radius: 24rem;
  padding: 40rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 28rem;
}

.esg-visionCard:hover {
  transform: translateY(-8rem);
  box-shadow: 0 5rem 10rem rgba(0, 0, 0, 0.05);
}

.esg-visionCard__icon {
  width: 64rem;
  height: 64rem;
  border-radius: 16rem;
  overflow: hidden;
  flex: 0 0 auto;
}

.esg-visionCard__icon img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.esg-visionCard__body {
  display: flex;
  flex-direction: column;
  gap: 12rem;
}

.esg-visionCard__title {
  margin: 0;
  font-size: 20rem;
  line-height: 28rem;
  font-weight: 500;
  color: #000;
}

.esg-visionCard__desc {
  margin: 0;
  font-size: 14rem;
  line-height: 24rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.64);
}

@media (max-width: 996px) {

  /* 375 design values ×2 */
  .esg-vision {
    padding-bottom: 0rem;
  }

  .esg-vision__inner {
    width: 100%;
    padding: 160rem 32rem;
    /* 80 * 2, 16 * 2 */
    border-radius: 0;
    /* keep same */
    gap: 80rem;
    /* 40 * 2 */
    margin: 0;
  }

  .esg-vision__title {
    font-size: 48rem;
    /* 24 * 2 */
    line-height: 72rem;
    /* 36 * 2 */
  }

  .esg-vision__grid {
    width: 100%;
    flex-direction: column;
    gap: 32rem;
    /* 16 * 2 */
  }

  .esg-visionCard {
    width: 100%;
    border-radius: 32rem;
    /* 16 * 2 */
    padding: 56rem 40rem;
    /* 28 * 2, 20 * 2 */
    flex-direction: row;
    gap: 40rem;
    /* 20 * 2 */
    align-items: flex-start;
  }

  .esg-visionCard--raised {
    transform: none;
    box-shadow: none;
  }

  .esg-visionCard__icon {
    width: 96rem;
    /* 48 * 2 */
    height: 96rem;
    border-radius: 24rem;
    /* 12 * 2 */
  }

  .esg-visionCard__body {
    gap: 8rem;
    /* 4 * 2 */
  }

  .esg-visionCard__title {
    font-size: 32rem;
    /* 16 * 2 */
    line-height: 48rem;
    /* 24 * 2 */
  }

  .esg-visionCard__desc {
    font-size: 28rem;
    /* 14 * 2 */
    line-height: 48rem;
    /* 24 * 2 */
  }
}

/* ESG - action (section5) */

.esg-action {
  width: 100%;
  background: #f7f7f7;
  padding: 120rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64rem;
}

.esg-action__title {
  margin: 0;
  font-size: 40rem;
  line-height: 48rem;
  font-weight: 700;
  color: #000;
  text-align: center;
}

.esg-action__wrap {
  width: 1200rem;
  display: grid;
  grid-template-columns: repeat(2, 588rem);
  gap: 23rem 24rem;
  justify-content: center;
}

.esg-actionCard {
  position: relative;
  width: 588rem;
  height: 368rem;
  overflow: hidden;
  color: #fff;
}

.esg-actionCard::before {
  content: "";
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  transform: scale(1);
  transition:
    filter 240ms ease,
    transform 240ms ease;
}

@media (min-width: 997px) {
  .esg-actionCard:hover::before {
    filter: blur(5px);
    transform: scale(1.03);
  }
}

.esg-actionCard--1 {
  border-radius: 24rem 24rem 150rem 24rem;
}

.esg-actionCard--1::before {
  background-image: url("../assets/image/ESG/section5Bg1.webp");
}

.esg-actionCard--2 {
  border-radius: 24rem 24rem 24rem 150rem;
}

.esg-actionCard--2::before {
  background-image: url("../assets/image/ESG/section5Bg2.webp");
}

.esg-actionCard--3 {
  border-radius: 24rem 150rem 24rem 24rem;
}

.esg-actionCard--3::before {
  background-image: url("../assets/image/ESG/section5Bg3.webp");
}

.esg-actionCard--4 {
  border-radius: 150rem 24rem 24rem 24rem;
}

.esg-actionCard--4::before {
  background-image: url("../assets/image/ESG/section5Bg4.webp");
}

.esg-actionCard__shade {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 150rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, #000 100%);
  mix-blend-mode: multiply;
  opacity: 0.7;
  pointer-events: none;
}

.esg-actionCard__text {
  position: absolute;
  left: 40rem;
  bottom: 40rem;
  right: 40rem;
}

.esg-actionCard--2 .esg-actionCard__text,
.esg-actionCard--4 .esg-actionCard__text {
  left: auto;
  width: 508rem;
  text-align: right;
}

.esg-actionCard__title {
  margin: 0;
  font-size: 24rem;
  line-height: 32rem;
  font-weight: 700;
  color: #fff;
}

.esg-actionCard__desc {
  margin: 8rem 0 0;
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.92);
  display: block;
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transform: translateY(6rem);
  transition:
    opacity 200ms ease,
    transform 200ms ease,
    max-height 200ms ease;
}

@media (min-width: 997px) {
  .esg-actionCard:hover .esg-actionCard__desc {
    opacity: 1;
    max-height: 80rem;
    transform: none;
  }
}

@media (max-width: 996px) {

  /* 375 design values ×2 */
  .esg-action {
    background: #fafafa;
    padding: 160rem 0;
    /* 80 * 2 */
    gap: 80rem;
    /* 40 * 2 */
  }

  .esg-action__title {
    font-size: 48rem;
    /* 24 * 2 */
    line-height: 72rem;
    /* 36 * 2 */
    padding: 0 32rem;
    box-sizing: border-box;
  }

  .esg-action__wrap {
    width: 100%;
    padding: 0 32rem;
    /* 16 * 2 */
    box-sizing: border-box;
    grid-template-columns: 1fr;
    gap: 32rem;
    /* 16 * 2 */
  }

  .esg-actionCard__shade {
    height: 100%;
  }

  .esg-actionCard {
    width: 100%;
    height: 430rem;
    /* ~214.67 * 2 */
    border-radius: 32rem !important;
    /* 16 * 2 */
  }

  .esg-actionCard__text {
    left: 48rem !important;
    /* ~23.33 * 2 */
    bottom: 48rem;
    right: 48rem;
    text-align: left !important;
  }

  .esg-actionCard__title {
    font-size: 32rem;
    /* 16 * 2 */
    line-height: 48rem;
    /* 24 * 2 */
    font-weight: 500;
    /* mobile is Medium */
    text-align: left !important;
  }

  .esg-actionCard__desc {
    display: block;
    margin-top: 10rem;
    font-size: 28rem;
    /* 14 * 2 */
    line-height: 44rem;
    /* 22 * 2 */
    opacity: 1;
    max-height: none;
    overflow: visible;
    transform: none;
    transition: none;
    text-align: left !important;
  }
}

.esg-6 {
  padding: 120rem 0;
  overflow: hidden;
}

.esg-6_list {
  gap: 24rem;
}

.esg-6 .p1 {
  margin-bottom: 64rem;
  font-size: 40rem;
  font-weight: 700;
  line-height: 48rem;
  text-align: center;
}

.esg-6 .esg-6_item {
  flex: 0 0 400rem;
}

.esg-6 .esg-6_item>a>img {
  display: block;
  width: 400rem;
  height: auto;
  object-fit: cover;
  border-radius: 12rem;
}

.esg-6 .esg-6_item .time {
  margin: 20rem 0 8rem;
  padding: 0 8rem;
  color: rgba(0, 0, 0, 0.64);
  font-size: 14rem;
  line-height: 22rem;
  letter-spacing: 0;
  border: 0;
  float: none;
  width: auto;
}

.esg-6 .esg-6_item .title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 8rem;
  color: #000;
  font-size: 16rem;
  line-height: 24rem;
  font-weight: 500;
  text-decoration: none;
}

@media (max-width: 996px) {
  .esg-6_list {
    gap: 29rem;
  }

  .esg-6 {
    padding: 160rem 0;
  }

  .esg-6 .p1 {
    margin-bottom: 80rem;
    font-size: 48rem;
    font-weight: 700;
    line-height: 72rem;
  }

  .esg-6 .esg-6_item {
    flex: 0 0 600rem;
  }

  /* 375 design values ×2 */
  .esg-6 .esg-6_item>a>img {
    width: 600rem;
    height: auto;
    /* 196 * 2 */
    border-radius: 21rem;
    /* 10.496 * 2 ≈ 21 */
  }

  .esg-6 .esg-6_item .time {
    margin: 40rem 0 16rem;
    font-size: 28rem;
    line-height: 44rem;
  }

  .esg-6 .esg-6_item .title {
    font-size: 32rem;
    line-height: 48rem;
  }
}
</style>
